import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import followUpApi from "../../api/followUpApi";
import DispositionApi from "../../api/DispositionApi";
import { showSuccess, showError } from "../../utils/toastUtils";
import PackageApi from "../../api/PackageApi";
import axios from "../../api/axiosinstance";
import PaymentApi from "../../api/paymentApi";

function FollowUp({ data, onSuccess }) {
  const [additionalPayments, setAdditionalPayments] = useState([
    {
      reason: "",
      amount: "",
    },
  ]);
  const navigate = useNavigate();

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const [leadSn, setLeadSn] = useState("");
  const [leadId, setLeadId] = useState("");

  const [dispositions, setDispositions] = useState([]);
  const [packages, setPackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState("");
  const [price, setPrice] = useState("");

  const [pendingAmount, setPendingAmount] = useState(0);

  const totalAdditionalAmount = additionalPayments.reduce(
    (acc, item) => acc + Number(item.amount || 0),
    0,
  );

  const totalAmount =
    Number(pendingAmount || 0) + Number(totalAdditionalAmount || 0);

  const [formData, setFormData] = useState({
    disposition: "",
    sub_disposition: "",
    remarks: "",
    fill_details: {},

    payment_amount: "",
    transaction_id: "",
    payment_mode: "",
    order_id: "",
    payment_date: "",
    callback_date: "",
  });

  const [commitments, setCommitments] = useState([
    { moduleName: "", description: "", price: "" },
  ]);

  const handleCommitmentChange = (index, key, value) => {
    const updated = [...commitments];
    updated[index][key] = value;
    setCommitments(updated);
  };

  const addCommitmentRow = () => {
    setCommitments([
      ...commitments,
      { moduleName: "", description: "", price: "" },
    ]);
  };

  const removeCommitmentRow = (index) => {
    const updated = commitments.filter((_, i) => i !== index);
    setCommitments(updated);
  };

  const fetchPendingPayment = async () => {
    try {
      const documentRes = await axios.get(`/documents/by-lead/${leadId}`);

      console.log("DOCUMENT RES:", documentRes);

      const latestDocument =
        documentRes?.data?.data?.[0] || documentRes?.data?.[0];

      if (!latestDocument) {
        setPendingAmount(0);

        return;
      }

      const totalAmount = Number(
        latestDocument.totalAmount || latestDocument.price || 0,
      );

      const paymentRes = await axios.get(`/payment/lead-summary/${leadId}`);

      console.log("PAYMENT RES:", paymentRes);

      const totalPaid = Number(paymentRes?.data?.totalPaid || 0);

      console.log("DOCUMENT:", latestDocument);

      console.log("TOTAL:", totalAmount);

      console.log("PAID:", totalPaid);

      const remaining = totalAmount - totalPaid;

      setPendingAmount(remaining > 0 ? remaining : 0);
    } catch (err) {
      console.log(err);

      setPendingAmount(0);
    }
  };

  const handleAdditionalPaymentChange = (index, key, value) => {
    const updated = [...additionalPayments];

    updated[index][key] = value;

    setAdditionalPayments(updated);
  };

  const addAdditionalPaymentRow = () => {
    setAdditionalPayments([
      ...additionalPayments,
      {
        reason: "",
        amount: "",
      },
    ]);
  };

  const removeAdditionalPaymentRow = (index) => {
    const updated = additionalPayments.filter((_, i) => i !== index);

    setAdditionalPayments(updated);
  };
  // const getActionType = () => {
  //   const sub = formData.sub_disposition?.toLowerCase();

  //   if (
  //     sub === "document sent to the customer" ||
  //     sub === "proposal with add-ons"
  //   ) {
  //     return "document";
  //   }

  //   if (
  //     formData.disposition === "Service Agreement Required" &&
  //     formData.sub_disposition === "Sent Service Agreement"
  //   ) {
  //     return "agreement";
  //   }

  //   return "followup";
  // };

  const getActionType = () => {
    const sub = formData.sub_disposition?.toLowerCase();

    if (
      sub === "document sent to the customer" ||
      formData.disposition === "Proposal with Add-ons"
    ) {
      return "document";
    }

    if (
      formData.disposition === "Service Agreement Required" &&
      formData.sub_disposition === "Sent Service Agreement"
    ) {
      return "agreement";
    }

    return "followup";
  };

  const getButtonText = () => {
    const action = getActionType();

    if (action === "document") return "Add Followup & Create Proposal";
    if (action === "agreement") return "Add Followup & Create Agreement";

    return "Add Followup";
  };
  /* ================== LOAD LEAD ================== */
  useEffect(() => {
    if (data) {
      setLeadSn(data.leadId);
      setLeadId(data._id);
    }
  }, [data]);

  /* ================== LOAD DISPOSITIONS ================== */
  useEffect(() => {
    fetchDispositions();
  }, []);

  /* ================== LOAD PACKAGES ================== */
  useEffect(() => {
    fetchPackages();
  }, []);

  useEffect(() => {
    if (formData.disposition === "Website Completed & Delivered" && leadId) {
      fetchPendingPayment();
    }
  }, [formData.disposition, leadId]);

  useEffect(() => {
    console.log("LEAD DATA", data);

    console.log("preferredDate =", data?.preferredDate);

    console.log("preferredTime =", data?.preferredTime);
  }, [data]);

  const fetchPackages = async () => {
    try {
      const res = await PackageApi.list();
      if (res.code === 200) {
        setPackages(res.data);
      }
    } catch {
      showError("Failed to load packages");
    }
  };

  const fetchDispositions = async () => {
    try {
      const res = await DispositionApi.list();

      if (res.code === 200) {
        const order = [
          "Interested",
          "Contacted",
          "Call Back",
          "Proposal with Add-ons",
          "Payment",
          "Website Completed & Delivered",
          "Converted",
          "Service Agreement Required",
          "Not Interested",
          "Denied by Us",
          "Escalated to Admin",
          "Did Not Pick Up",
          "Wrong No",
          "Others",
        ];

        const sorted = (res.data || []).sort((a, b) => {
          const indexA = order.indexOf(a.name);
          const indexB = order.indexOf(b.name);
          if (indexA === -1) return 1;
          if (indexB === -1) return -1;
          return indexA - indexB;
        });

        setDispositions(sorted);
      } else {
        showError(res.message);
      }
    } catch {
      showError("Failed to load dispositions");
    }
  };

  /* ================== INPUT HANDLERS ================== */
  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedForm = {
      ...formData,
      [name]: value,
      ...(name === "disposition"
        ? {
            sub_disposition: "",
            fill_details: {},
          }
        : {}),
    };

    // Auto Fill Preferred Date & Time
    if (name === "sub_disposition" && value === "Scheduled Meeting") {
      updatedForm.fill_details = {
        ...updatedForm.fill_details,

        meetingDate: data?.preferredDate || "",

        meetingTime: data?.preferredTime || "",
      };
    }

    setFormData(updatedForm);

    if (name === "disposition") {
      setSelectedPackage("");
      setCommitments([
        {
          moduleName: "",
          description: "",
          price: "",
        },
      ]);
    }
  };

  const handleInputChange = (key, value, isDynamic = false) => {
    setFormData((prev) => {
      if (isDynamic) {
        return {
          ...prev,
          fill_details: {
            ...prev.fill_details,
            [key]: value,
          },
        };
      }
      return { ...prev, [key]: value };
    });
  };

  /* ================== VALIDATION ================== */
  const validate = () => {
    const newErrors = {};

    // ✅ Remarks mandatory (TOASTER)
    if (!formData.remarks) {
      showError("Remarks is required");
      return false;
    }

    if (!formData.disposition) {
      showError("Please select disposition");
      return false;
    }

    if (
      formData.disposition === "Call Back" &&
      !formData.fill_details?.callbackDateTime
    ) {
      showError("Callback Date & Time is required");
      return false;
    }

    // Quotation Required
    if (formData.disposition === "Quotation Required" && !selectedPackage) {
      newErrors.package = "Please select a package";
    }

    if (formData.disposition === "Proposal with Add-ons") {
      if (!selectedPackage) {
        showError("Please select package");
        return false;
      }

      const validCommitments = commitments.filter(
        (c) => c.moduleName?.trim() || c.description?.trim() || c.price,
      );

      if (!validCommitments.length) {
        showError("Add at least one commitment");
        return false;
      }

      for (const item of validCommitments) {
        if (!item.moduleName?.trim()) {
          showError("Module Name is required");
          return false;
        }

        if (!item.description?.trim()) {
          showError("Description is required");
          return false;
        }

        if (
          item.price === "" ||
          item.price === null ||
          Number(item.price) <= 0
        ) {
          showError("Commitment price must be greater than 0");
          return false;
        }
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* ================== SUBMIT ================== */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    const actionType = getActionType();

    setLoading(true);

    try {
      const payload = {
        payment_amount: Number(formData.payment_amount || 0),
        transaction_id: formData.transaction_id,

        payment_mode: formData.payment_mode,

        order_id: formData.order_id,

        payment_date: formData.payment_date || null,
        leadId,

        disposition: formData.disposition,

        sub_disposition: formData.sub_disposition,

        fill_details: formData.fill_details,

        remarks: formData.remarks,

        packageId: selectedPackage || null,

        price: Number(price || 0),
        pendingAmount,

        totalAmount,

        callback_date: formData.fill_details?.callbackDateTime || null,
        additionalPayments:
          formData.disposition === "Website Completed & Delivered"
            ? additionalPayments
                .filter((item) => item.reason || item.amount)
                .map((item) => ({
                  ...item,
                  amount: Number(item.amount || 0),
                }))
            : [],
        commitments:
          formData.disposition === "Proposal with Add-ons"
            ? commitments.filter(
                (c) => c.moduleName || c.description || c.price,
              )
            : [],
      };

      const res = await followUpApi.add(payload);

      if (res.code === 200) {
        showSuccess(res.message);

        if (actionType === "document" && selectedPackage) {
          document.getElementById("closeOffcanvasBtn").click();

          const proposalState = {
            commitments:
              formData.disposition === "Proposal with Add-ons"
                ? commitments
                    .filter((c) => c.moduleName || c.description || c.price)
                    .map((c) => ({
                      ...c,
                      price: Number(c.price || 0),
                    }))
                : [],
            disposition: formData.disposition,
            sub_disposition: formData.sub_disposition,
            price,
          };

          sessionStorage.setItem(
            "proposalState",
            JSON.stringify(proposalState),
          );

          window.open(
            `${window.location.origin}/document/create/${leadId}?packageId=${selectedPackage}`,
            "_blank",
          );

          document.getElementById("closeOffcanvasBtn").click();

          onSuccess();

          return;

          return;
        }

        if (actionType === "agreement") {
          try {
            const agreementRes = await axios.post("/service-agreement/create", {
              leadId,
            });

            console.log("AGREEMENT RESPONSE:", agreementRes);

            const agreementId = agreementRes?.data?._id;

            showSuccess("Agreement Created ✅");

            document.getElementById("closeOffcanvasBtn").click();

            navigate(`/agreement/view/${agreementId}`);

            return;
          } catch (err) {
            console.log(err);

            showError("Agreement creation failed");
          }
        }

        // ✅ NORMAL FOLLOWUP FLOW
        document.getElementById("closeOffcanvasBtn").click();

        setFormData({
          disposition: "",
          sub_disposition: "",
          remarks: "",
          fill_details: {},

          payment_amount: "",
          transaction_id: "",
          payment_mode: "",
          order_id: "",
          payment_date: "",
          callback_date: "",
        });
        setSelectedPackage("");
        setCommitments([{ moduleName: "", description: "", price: "" }]);

        onSuccess();
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(
        err?.response?.data?.message || err.message || "Something went wrong",
      );
    } finally {
      setLoading(false);
    }
  };

  /* ================== CURRENT SELECTION ================== */
  const currentDisposition = dispositions.find(
    (d) => d.name === formData.disposition,
  );

  const currentSub =
    currentDisposition?.sub?.find((s) => s.name === formData.sub_disposition) ||
    null;

  /* ================== NAVIGATION ================== */
  const handleCreateProposal = () => {
    document.getElementById("closeOffcanvasBtn").click();
    navigate(`/proposal/create/${leadId}`);
  };

  const createProposalAuto = async () => {
    try {
      const res = await axios.post("/proposals/auto-create", {
        leadId,
        packageId: selectedPackage,
      });

      if (res.data.code === 200) {
        showSuccess("Proposal created & sent 🚀");

        document.getElementById("closeOffcanvasBtn").click();
        onSuccess();
      }
    } catch (err) {
      console.log(err);
      showError("Auto proposal failed");
    }
  };

  /* ================== UI ================== */
  return (
    <div>
      <div className="offcanvas-header">
        <h5>Add FollowUp</h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          id="closeOffcanvasBtn"
        />
      </div>

      <div className="offcanvas-body">
        <form onSubmit={handleSubmit}>
          <p>S.No. {leadSn}</p>

          {/* DISPOSITION */}
          <div className="mb-3">
            <label>Disposition</label>
            <select
              className="form-control"
              value={formData.disposition}
              onChange={handleChange}
              name="disposition"
            >
              <option value="">Select Disposition</option>
              {dispositions.map((d) => (
                <option key={d._id} value={d.name}>
                  {d.name}
                </option>
              ))}
            </select>
            {errors.disposition && (
              <span className="text-danger">{errors.disposition}</span>
            )}
          </div>

          {/* SUB DISPOSITION */}
          {currentDisposition?.sub && (
            <div className="mb-3">
              <label>Sub-Disposition</label>
              <select
                className="form-control"
                value={formData.sub_disposition}
                onChange={handleChange}
                name="sub_disposition"
              >
                <option value="">Select Sub-Disposition</option>
                {currentDisposition.sub.map((sub) => (
                  <option key={sub.name} value={sub.name}>
                    {sub.name}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* DYNAMIC FIELDS */}

          {currentSub?.subMenus?.map((field) => (
            <div className="mb-3" key={field.key}>
              <label>{field.label}</label>

              <input
                type={
                  field.type === "datetime"
                    ? "datetime-local"
                    : field.type === "date"
                      ? "date"
                      : field.type === "time"
                        ? "time"
                        : "text"
                }
                className="form-control"
                value={formData.fill_details?.[field.key] || ""}
                onChange={(e) =>
                  handleInputChange(field.key, e.target.value, true)
                }
              />
            </div>
          ))}

          {(formData.disposition === "Quotation Required" ||
            formData.disposition === "Proposal with Add-ons" ||
            (formData.disposition === "Contacted" &&
              formData.sub_disposition?.toLowerCase() ===
                "document sent to the customer")) && (
            <>
              <div className="mb-3">
                <label>Select Package</label>
                <select
                  className="form-control"
                  value={selectedPackage}
                  onChange={(e) => setSelectedPackage(e.target.value)}
                >
                  <option value="">Select Package</option>
                  {packages.map((p) => (
                    <option key={p._id} value={p._id}>
                      {p.packageName}
                    </option>
                  ))}
                </select>

                {errors.package && (
                  <span className="text-danger">{errors.package}</span>
                )}
              </div>

              {/* ✅ PRICE FIELD */}
              <div className="mb-4">
                <h5 className="text-primary fw-bold">Price (Optional)</h5>

                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter price (optional)"
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                />
              </div>
            </>
          )}

          {/* ADDITIONAL COMMITMENTS */}
          {/* ADDITIONAL COMMITMENTS */}
          {/* ADDITIONAL COMMITMENTS */}
          {formData.disposition === "Proposal with Add-ons" && (
            <div className="mb-4">
              {/* HEADER */}
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                <h5
                  className="mb-0"
                  style={{
                    color: "#dc2626",
                    fontWeight: "700",
                  }}
                >
                  Additional Commitments
                </h5>

                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger px-3"
                  onClick={addCommitmentRow}
                  style={{
                    borderRadius: "8px",
                    fontWeight: "600",
                  }}
                >
                  + Add Row
                </button>
              </div>

              {/* ROWS */}
              {commitments.map((c, i) => (
                <div key={i} className="row g-2 align-items-center mb-2">
                  {/* MODULE */}
                  <div className="col-md-4">
                    <input
                      className="form-control"
                      placeholder="Module Name"
                      value={c.moduleName}
                      onChange={(e) =>
                        handleCommitmentChange(i, "moduleName", e.target.value)
                      }
                    />
                  </div>

                  {/* DESCRIPTION */}
                  <div className="col-md-5">
                    <textarea
                      className="form-control"
                      rows="3"
                      placeholder="Description"
                      value={c.description}
                      onChange={(e) =>
                        handleCommitmentChange(i, "description", e.target.value)
                      }
                    />
                  </div>

                  {/* PRICE */}
                  <div className="col-md-2">
                    <input
                      type="number"
                      min="0"
                      step="1"
                      className="form-control"
                      placeholder="Price"
                      value={c.price}
                      onChange={(e) =>
                        handleCommitmentChange(i, "price", e.target.value)
                      }
                    />
                  </div>

                  {/* DELETE */}
                  <div className="col-md-1">
                    {commitments.length > 1 && (
                      <button
                        type="button"
                        className="btn btn-danger w-100"
                        onClick={() => removeCommitmentRow(i)}
                      >
                        ✕
                      </button>
                    )}
                  </div>
                </div>
              ))}

              {/* ERROR */}
              {errors.commitments && (
                <div className="text-danger mt-2">{errors.commitments}</div>
              )}
            </div>
          )}
          {/* PAYMENT DETAILS */}
          {formData.disposition === "Payment" && (
            <div className="card border-0 shadow-sm mb-3">
              <div className="card-body">
                <h5 className="mb-3 text-primary">Payment Details</h5>

                <div className="row">
                  {/* AMOUNT */}
                  <div className="col-md-12 mb-3">
                    <label>Amount</label>

                    <input
                      type="number"
                      className="form-control"
                      value={formData.payment_amount}
                      onChange={(e) =>
                        handleInputChange("payment_amount", e.target.value)
                      }
                    />
                  </div>

                  {/* TRANSACTION ID */}
                  <div className="col-md-6 mb-3">
                    <label>Payment ID</label>

                    <input
                      type="text"
                      className="form-control"
                      value={formData.transaction_id}
                      onChange={(e) =>
                        handleInputChange("transaction_id", e.target.value)
                      }
                    />
                  </div>

                  {/* MODE */}
                  <div className="col-md-6 mb-3">
                    <label>Payment Mode</label>

                    <select
                      className="form-control"
                      value={formData.payment_mode}
                      onChange={(e) =>
                        handleInputChange("payment_mode", e.target.value)
                      }
                    >
                      <option value="">Select Mode</option>

                      <option value="Cash">Cash</option>

                      <option value="UPI">UPI</option>

                      <option value="Bank Transfer">Bank Transfer</option>

                      <option value="Cheque">Cheque</option>
                    </select>
                  </div>

                  {/* ORDER ID */}
                  <div className="col-md-6 mb-3">
                    <label>Order ID</label>

                    <input
                      type="text"
                      className="form-control"
                      value={formData.order_id}
                      onChange={(e) =>
                        handleInputChange("order_id", e.target.value)
                      }
                    />
                  </div>

                  {/* DATE */}
                  <div className="col-md-12 mb-2">
                    <label>Date & Time</label>

                    <input
                      type="datetime-local"
                      className="form-control"
                      value={formData.payment_date}
                      onChange={(e) =>
                        handleInputChange("payment_date", e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* CALLBACK DATE TIME */}

          {formData.disposition === "Website Completed & Delivered" && (
            <div className="card border-0 shadow-sm mb-3">
              <div className="card-body">
                <h5
                  className="mb-4"
                  style={{
                    color: "#dc2626",
                    fontWeight: "700",
                  }}
                >
                  Website Delivery Details
                </h5>

                {/* WEBSITE URL */}

                <div className="mb-3">
                  <label>Website URL</label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="https://example.com"
                    value={formData.fill_details?.websiteUrl || ""}
                    onChange={(e) =>
                      handleInputChange("websiteUrl", e.target.value, true)
                    }
                  />
                </div>

                {/* PENDING */}

                <div className="row">
                  {/* PENDING */}
                  <div className="col-md-6 mb-3">
                    <label className="fw-semibold">Pending Payment</label>

                    <input
                      type="text"
                      className="form-control"
                      readOnly
                      value={`₹ ${pendingAmount}`}
                    />
                  </div>

                  {/* TOTAL */}
                </div>

                {/* ADDITIONAL PAYMENTS */}

                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6
                    className="mb-0"
                    style={{
                      color: "#dc2626",
                      fontWeight: "700",
                    }}
                  >
                    Additional Payments
                  </h6>

                  <button
                    type="button"
                    className="btn btn-sm btn-outline-danger"
                    onClick={addAdditionalPaymentRow}
                  >
                    + Add Row
                  </button>
                </div>

                {additionalPayments.map((item, index) => (
                  <div className="row mb-2" key={index}>
                    <div className="col-md-7">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Reason"
                        value={item.reason}
                        onChange={(e) =>
                          handleAdditionalPaymentChange(
                            index,
                            "reason",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-md-4">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Amount"
                        value={item.amount}
                        onChange={(e) =>
                          handleAdditionalPaymentChange(
                            index,
                            "amount",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-md-1">
                      {additionalPayments.length > 1 && (
                        <button
                          type="button"
                          className="btn btn-danger w-100"
                          onClick={() => removeAdditionalPaymentRow(index)}
                        >
                          ✕
                        </button>
                      )}
                    </div>
                  </div>
                ))}

                {/* TOTAL AMOUNT */}
                <div
                  className="mt-3 p-3 rounded"
                  style={{
                    background: "#fef2f2",
                    border: "1px solid #fecaca",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <span
                      style={{
                        fontWeight: "700",
                        color: "#dc2626",
                      }}
                    >
                      Total Amount
                    </span>

                    <span
                      style={{
                        fontWeight: "700",
                        fontSize: "18px",
                        color: "#dc2626",
                      }}
                    >
                      ₹{" "}
                      {Number(pendingAmount || 0) +
                        additionalPayments.reduce(
                          (acc, item) => acc + Number(item.amount || 0),
                          0,
                        )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* {formData.disposition === "Call Back" && (
            <div className="mb-3">
              <label>Callback Date & Time</label>

              <input
                type="datetime-local"
                className="form-control"
                value={formData.fill_details?.callbackDateTime || ""}
                onChange={(e) =>
                  handleInputChange("callbackDateTime", e.target.value, true)
                }
              />
            </div>
          )} */}
          {/* REMARKS */}
          {formData.disposition && (
            <div className="mb-3">
              <label>Remarks</label>
              <br></br>

              <textarea
                className="form-control"
                rows="3"
                value={formData.remarks}
                onChange={(e) => handleInputChange("remarks", e.target.value)}
              />
            </div>
          )}

          {/* SUBMIT */}
          <button
            type="submit"
            className="btn btn-success w-100"
            disabled={loading}
          >
            {loading ? "Processing..." : getButtonText()}
          </button>

          {/* PROPOSAL */}
          {formData.disposition === "Proposal Sent" && (
            <button
              type="button"
              className="btn btn-primary w-100 mt-2"
              onClick={handleCreateProposal}
            >
              Create Proposal
            </button>
          )}
        </form>
      </div>
    </div>
  );
}

export default FollowUp;
